<div class="request-access-container">
  <h1>Request Access</h1>

  <form [formGroup]="requestForm" (ngSubmit)="submitRequest()">
    <mat-label>User Email</mat-label>
    <mat-form-field appearance="fill" class="full-width">
      <input matInput [value]="loggedInuser?.email" formControlName="userEmail" placeholder="Enter your email" />
      <mat-error *ngIf="requestForm.get('userEmail')?.hasError('required')">
        Email is required.
      </mat-error>
      <mat-error *ngIf="requestForm.get('userEmail')?.hasError('email')">
        Enter a valid email address.
      </mat-error>
    </mat-form-field>

    <mat-label>Select Module</mat-label>
    <mat-form-field appearance="fill" class="full-width">
      <mat-select placeholder="Select Module" formControlName="selectedModule" multiple>
        <mat-option *ngFor="let list of module" [value]="list">
          {{ list }}
        </mat-option>
      </mat-select>
      <mat-error *ngIf="requestForm.get('selectedModule')?.hasError('required')">
        Module is required.
      </mat-error>
    </mat-form-field>

<mat-label>Select Sub-Module</mat-label>
<mat-form-field appearance="fill" class="full-width">
  <mat-select placeholder="Select Sub-Module" formControlName="selectedSubModule" multiple>
    <mat-option *ngFor="let list of subModule" [value]="list">
      {{ list }}
    </mat-option>
  </mat-select>
  <mat-error *ngIf="requestForm.get('selectedSubModule')?.hasError('required')">
    Sub Module is required.
  </mat-error>
</mat-form-field>


    <mat-label>Reason for Request</mat-label>
    <mat-form-field appearance="fill" class="full-width">
      <textarea matInput formControlName="reason" placeholder="Enter your reason"></textarea>
      <mat-error *ngIf="requestForm.get('reason')?.hasError('required')">
        Reason is required.
      </mat-error>
    </mat-form-field>

    <div class="submit-btn" >
      <button mat-raised-button color="primary" type="submit" [disabled]="requestForm.invalid">
      Submit Request
    </button>
    </div>    
  </form>
</div>